import { render, staticRenderFns } from "./semesterForm.vue?vue&type=template&id=646f19b6&"
import script from "./semesterForm.vue?vue&type=script&lang=js&"
export * from "./semesterForm.vue?vue&type=script&lang=js&"
import style0 from "./semesterForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports